export const bank = [
  {
    Id_Banco: 70,
    Codigo_Banco: '0233',
    Nombre_Banco: 'MUTUALISTA AMBATO',
    Banco_Local: true,
    Url: 'http://www.mutualistaambato.fin.ec/index.php/creditos/',
  },
  {
    Id_Banco: 71,
    Codigo_Banco: '0234',
    Nombre_Banco: 'MUTUALISTA AZUAY',
    Banco_Local: true,
    Url: 'https://info.mutualistaazuay.com/Menu-Principal/Productos/mazCR%C3%89DITO/CONSUMO/Compras-varias',
  },
  {
    Id_Banco: 73,
    Codigo_Banco: '0236',
    Nombre_Banco: 'MUTUALISTA IMBABURA',
    Banco_Local: true,
    Url: 'http://www.mutualistaimbabura.com/credi-amigo/',
  },
  {
    Id_Banco: 75,
    Codigo_Banco: '0238',
    Nombre_Banco: 'MUTUALISTA PICHINCHA',
    Banco_Local: true,
    Url: 'https://www.mutualistapichincha.com/web/guest/creditos',
  },
  {
    Id_Banco: 82,
    Codigo_Banco: '0522',
    Nombre_Banco: 'CAMARA DE COMERCIO JOYA DE LOS SACHAS',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 90,
    Codigo_Banco: '0537',
    Nombre_Banco: 'CORPORACION EN LAS HUELLAS DEL BCO GRAMEEN',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 91,
    Codigo_Banco: '0543',
    Nombre_Banco: 'CAJA DE AHORRO Y CREDITO SAN FRANCISCO',
    Banco_Local: true,
    Url: 'http://cotizador.coac-sanfra.com/',
  },
  {
    Id_Banco: 95,
    Codigo_Banco: '0553',
    Nombre_Banco: 'CAJA DE AHORRO Y CREDITO FRANCISCA CHIGUA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 97,
    Codigo_Banco: '0558',
    Nombre_Banco: 'CAJA SOLIDARIA ESTRELLA DEL MUNDO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 130,
    Codigo_Banco: '0469',
    Nombre_Banco: 'FONDO DE CESANTIA DEL MAGISTERIO ECUAT FCME-FCPC',
    Banco_Local: true,
    Url: 'https://www.fcme.com.ec/financieros/creditos-quirografarios/',
  },
  {
    Id_Banco: 191,
    Codigo_Banco: '0542',
    Nombre_Banco: 'CAJA DE AHORRO Y CREDITO FRONTERA SUR',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 196,
    Codigo_Banco: '0562',
    Nombre_Banco: 'CORPORACION VIENTOS SOLIDARIOS',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 225,
    Codigo_Banco: '0588',
    Nombre_Banco: 'CAJA SOLIDARIA DE A Y C CORDTUCH',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 226,
    Codigo_Banco: '0541',
    Nombre_Banco: 'CAJA DE AHORRO Y CREDITO MANU',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 228,
    Codigo_Banco: '0550',
    Nombre_Banco: 'CAJA DE AHORRO Y CREDITO EL INGENIO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 229,
    Codigo_Banco: '0552',
    Nombre_Banco: 'CAJA DE A Y C NUESTRA SENORA DE LA MERCED',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 230,
    Codigo_Banco: '0554',
    Nombre_Banco: 'CAJA DE AHORRO Y CREDITO EL MANIZAL',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 231,
    Codigo_Banco: '0557',
    Nombre_Banco: 'CAJA SOLIDARIA CHIQUICHA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 300,
    Codigo_Banco: '0618',
    Nombre_Banco: 'CAJA DE A Y C JUVENTUD Y DESARROLLO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 303,
    Codigo_Banco: '0540',
    Nombre_Banco: 'CAJA DE AHORRO Y CREDITO ZHONDELEG',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 362,
    Codigo_Banco: '1010',
    Nombre_Banco: 'CAJA DE AHORRO Y CREDITO BANCAJA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 363,
    Codigo_Banco: '1011',
    Nombre_Banco: 'CAJA ECUAESPANA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 65,
    Codigo_Banco: '0227',
    Nombre_Banco: 'COOP.AHORRO Y CREDITO ALIANZA DEL VALLE LTDA',
    Banco_Local: true,
    Url: 'https://servicios.alianzadelvalle.fin.ec/cooperativa-en-linea/#/public/SimuladorCredito',
  },
  {
    Id_Banco: 66,
    Codigo_Banco: '0228',
    Nombre_Banco: 'COOP AHORRO Y CREDITO CONSTRC COMERCIO Y PRODUC',
    Banco_Local: true,
    Url: 'https://www.coopccp.fin.ec/index.php/creditos/credito-de-consumo',
  },
  {
    Id_Banco: 67,
    Codigo_Banco: '0229',
    Nombre_Banco: 'COOP.AHORRO Y CREDITO CHONE LTDA',
    Banco_Local: true,
    Url: 'http://www.coopchone.fin.ec/creditos.php',
  },
  {
    Id_Banco: 68,
    Codigo_Banco: '0231',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO SANTA ANA LTDA',
    Banco_Local: true,
    Url: 'https://www.coopsantana.fin.ec/credito-y-microcredito',
  },
  {
    Id_Banco: 77,
    Codigo_Banco: '0505',
    Nombre_Banco: 'COOP DE A Y C JADAN LTDA (MIES)',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 78,
    Codigo_Banco: '0510',
    Nombre_Banco: 'COOP DE A Y C ACCION TUNGURAHUA LTDA',
    Banco_Local: true,
    Url: 'http://acciontungurahua.fin.ec/index.php/component/sppagebuilder/13-creditos',
  },
  {
    Id_Banco: 79,
    Codigo_Banco: '0516',
    Nombre_Banco: 'COOP A Y C NUEVOS HORIZONTES EL ORO LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 80,
    Codigo_Banco: '0519',
    Nombre_Banco: 'COOP A Y C ESC SUP POLITEC AGROP DE MANABI MANUEL',
    Banco_Local: true,
    Url: 'https://www.coopcomer.fin.ec/creditos.html',
  },
  {
    Id_Banco: 81,
    Codigo_Banco: '0521',
    Nombre_Banco: 'COOP DE A Y C EDUCACIONES TULCAN LTDA',
    Banco_Local: true,
    Url: 'http://www.coaceducadorestulcan.fin.ec/index.php/servicios/simulador-de-creditos',
  },
  {
    Id_Banco: 84,
    Codigo_Banco: '0524',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO CRECIENDO JUNTOS ',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 85,
    Codigo_Banco: '0525',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO GUEL LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 87,
    Codigo_Banco: '0531',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO LA FLORIDA',
    Banco_Local: true,
    Url: 'https://www.floridacoop.com/copy-of-poliza-de-seguros',
  },
  {
    Id_Banco: 88,
    Codigo_Banco: '0532',
    Nombre_Banco: 'COOP DE A Y C SAN SANTIAGO DE MOLLETURO LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 98,
    Codigo_Banco: '0559',
    Nombre_Banco: 'COOP DE A Y C DESARROLLO POPULAR',
    Banco_Local: true,
    Url: 'http://www.accionydesarrollo.fin.ec/index.php/servicios/credito/micro-credito',
  },
  {
    Id_Banco: 100,
    Codigo_Banco: '0563',
    Nombre_Banco: 'COOP. AGUILAS DE CRISTO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 101,
    Codigo_Banco: '0566',
    Nombre_Banco: 'COOP OLMEDO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 102,
    Codigo_Banco: '0567',
    Nombre_Banco: 'COOP. DE AHO Y CRED LOS ANDES LATINOS LTDA.',
    Banco_Local: true,
    Url: 'https://cooplosandeslatinos.com/credito-de-consumo/',
  },
  {
    Id_Banco: 103,
    Codigo_Banco: '0570',
    Nombre_Banco: 'COOP. DE A. Y C. SALASACA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 104,
    Codigo_Banco: '0572',
    Nombre_Banco: 'COOP. DE AHO Y CRED INTERCULT. TARPUK RUNA LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 105,
    Codigo_Banco: '0573',
    Nombre_Banco: 'COOP. DE A. Y C. VIRGEN DEL CISNE',
    Banco_Local: true,
    Url: 'http://www.virgendelcisne.fin.ec/index.php/es/productos-servicios/creditos/consumo/creditos-de-consumo',
  },
  {
    Id_Banco: 106,
    Codigo_Banco: '0574',
    Nombre_Banco: 'C. DE A Y C EDUCAD. DE ZAMORA CHINCHIPE',
    Banco_Local: true,
    Url: 'http://www.virgendelcisne.fin.ec/index.php/es/',
  },
  {
    Id_Banco: 107,
    Codigo_Banco: '0575',
    Nombre_Banco: 'C. DE AH. Y CREDITO LAS LAGUNAS (MIESS)',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 108,
    Codigo_Banco: '0578',
    Nombre_Banco: 'C  DE A Y C EMPLEAD BANCAR DEL ORO LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 109,
    Codigo_Banco: '0580',
    Nombre_Banco: 'C. DE A. Y C. SAN MARTIN DE TISALEO LTDA.',
    Banco_Local: true,
    Url: 'http://sanmartin.fin.ec/productos/creditos/simulador-creditos.html',
  },
  {
    Id_Banco: 110,
    Codigo_Banco: '0581',
    Nombre_Banco: 'COOP. DE A. Y C. ALLI TARPUC LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 111,
    Codigo_Banco: '0582',
    Nombre_Banco: 'C. DE A Y C. SAN MIGUEL DE PALLATANGA',
    Banco_Local: true,
    Url: 'https://coacsmp.com/creditos/',
  },
  {
    Id_Banco: 112,
    Codigo_Banco: '0585',
    Nombre_Banco: 'COOP. DE LA MICROEMP. DE CHIMBORAZO',
    Banco_Local: true,
    Url: 'http://estadictica.blogspot.com/p/blog-page.html',
  },
  {
    Id_Banco: 115,
    Codigo_Banco: '0451',
    Nombre_Banco: 'COOP. DE A. Y C. DESARROLLO INTEGRAL LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 116,
    Codigo_Banco: '0252',
    Nombre_Banco: 'COOP. CREDITO Y AHORRO SAN FRANCISCO DE ASIS',
    Banco_Local: true,
    Url: 'http://www.coac-sanfra.com/formulario-solicitud-de-credito/',
  },
  {
    Id_Banco: 117,
    Codigo_Banco: '0452',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO EL CALVARIO LTDA',
    Banco_Local: true,
    Url: 'https://coopcalvario.webcindario.com/consumo-ordinario.html',
  },
  {
    Id_Banco: 118,
    Codigo_Banco: '0296',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO ALFONSO JARAMILLO',
    Banco_Local: true,
    Url: 'https://www.caja.com.ec/calculadora-creditos',
  },
  {
    Id_Banco: 119,
    Codigo_Banco: '0204',
    Nombre_Banco: 'C.PEQ.EMPRESA DE PASTAZA',
    Banco_Local: true,
    Url: 'https://www.cacpepas.fin.ec/cacpeonline/login/consultas',
  },
  {
    Id_Banco: 120,
    Codigo_Banco: '8000',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO MANANTIAL DE ORO LTDA.',
    Banco_Local: true,
    Url: 'https://manantialdeoro.wordpress.com/calendario/',
  },
  {
    Id_Banco: 121,
    Codigo_Banco: '8002',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO ACCION Y DESARROLLO LTDA',
    Banco_Local: true,
    Url: 'http://www.accionydesarrollo.fin.ec/index.php/servicios/credito/micro-credito',
  },
  {
    Id_Banco: 122,
    Codigo_Banco: '8001',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO ANDINA LTDA.',
    Banco_Local: true,
    Url: 'https://www.coopandina.fin.ec/lineas-de-credito/',
  },
  {
    Id_Banco: 123,
    Codigo_Banco: '0453',
    Nombre_Banco: 'COOP. DE A. Y C. JUAN PIO DE MORA LTDA',
    Banco_Local: true,
    Url: 'https://www.juanpiodemora.fin.ec/simulador-credito/',
  },
  {
    Id_Banco: 124,
    Codigo_Banco: '0219',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO RIOBAMBA',
    Banco_Local: true,
    Url: 'https://www.cooprio.fin.ec/index.php/productos-servicios/creditos/creditos-consumo',
  },
  {
    Id_Banco: 126,
    Codigo_Banco: '0462',
    Nombre_Banco: 'COOP DE A Y C DE SERV PUBL DEL MIN EDUCACION Y CUL',
    Banco_Local: true,
    Url: 'https://www.cacspmec.fin.ec/prestamoso.html',
  },
  {
    Id_Banco: 127,
    Codigo_Banco: '0463',
    Nombre_Banco: 'COOP DE A Y C 23 DE MAYO LTDA',
    Banco_Local: true,
    Url: 'http://www.coop23demayo.fin.ec/',
  },
  {
    Id_Banco: 128,
    Codigo_Banco: '0464',
    Nombre_Banco: 'COOP DE A Y C COCA LTDA',
    Banco_Local: true,
    Url: 'http://www.cocaltda.fin.ec/simulador-de-credito/',
  },
  {
    Id_Banco: 129,
    Codigo_Banco: '0467',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO HUAICANA LTDA',
    Banco_Local: true,
    Url: 'https://huaicana.fin.ec/creditos/',
  },
  {
    Id_Banco: 131,
    Codigo_Banco: '0472',
    Nombre_Banco: 'COOP DE A Y C BANOS LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 132,
    Codigo_Banco: '0474',
    Nombre_Banco: 'COOP DE A Y C CREDI FACIL LTDA',
    Banco_Local: true,
    Url: 'http://cooperativacredifacil.fin.ec/index.php/servicios/simulador-de-credito',
  },
  {
    Id_Banco: 133,
    Codigo_Banco: '0475',
    Nombre_Banco: 'COOP DE A Y C VENCEDORES DE TUNGURAHUA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 134,
    Codigo_Banco: '0479',
    Nombre_Banco: 'COOP ESFUERZO UNIDO PARA EL DESARR DEL CHILCO ',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 135,
    Codigo_Banco: '0481',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO SIMIATUG LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 136,
    Codigo_Banco: '0482',
    Nombre_Banco: 'COOP DE A Y C SINCHI RUNA LTDA',
    Banco_Local: true,
    Url: 'http://coacsinchiruna.blogspot.com/',
  },
  {
    Id_Banco: 137,
    Codigo_Banco: '0485',
    Nombre_Banco: 'COOP DE A Y C SIERRA CENTRO LTDA',
    Banco_Local: true,
    Url: 'https://www.sierracentro.fin.ec/home.php#',
  },
  {
    Id_Banco: 138,
    Codigo_Banco: '0486',
    Nombre_Banco: 'COOP DE A Y C GONZANAMA MIES',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 139,
    Codigo_Banco: '0488',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO 27 DE ABRIL LOJA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 140,
    Codigo_Banco: '0491',
    Nombre_Banco: 'COOP A Y C PROFESIONALES DEL VOLANTE UNION LTDA ',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 141,
    Codigo_Banco: '0493',
    Nombre_Banco: 'COOP DE A Y C FUTURO Y PROGRESO DE GALAPAGOS LTDA ',
    Banco_Local: true,
    Url: 'http://cooperativafuprogal.fin.ec/productos/creditos',
  },
  {
    Id_Banco: 143,
    Codigo_Banco: '0499',
    Nombre_Banco: 'COOP DE A Y C CASAG LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 145,
    Codigo_Banco: '0509',
    Nombre_Banco: 'COOP DE A Y C INKA KIPU LTDA',
    Banco_Local: true,
    Url: 'https://www.guimun.com/ecuador/negocios/1157/inka-kipu-ltda-cooperativa-de-ahorro-y-crdito',
  },
  {
    Id_Banco: 146,
    Codigo_Banco: '0455',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO PUCARA LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 147,
    Codigo_Banco: '0270',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO JUAN DE SALINAS LTDA.',
    Banco_Local: true,
    Url: 'https://coacsalinas.fin.ec/productos-y-servicios/creditos/',
  },
  {
    Id_Banco: 148,
    Codigo_Banco: '0271',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO PUELLARO LTDA',
    Banco_Local: true,
    Url: 'http://coacpuellaro.fin.ec/simulador-de-inversiones-cooperativa-puellaro.html',
  },
  {
    Id_Banco: 149,
    Codigo_Banco: '0272',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO NUEVA JERUSALEN',
    Banco_Local: true,
    Url: 'https://www.nvjerusalen.org/index.php/servicios-productos/creditos/',
  },
  {
    Id_Banco: 150,
    Codigo_Banco: '0273',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO MALCHINGUI LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 151,
    Codigo_Banco: '0275',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO AGRARIA MUSHUK KAWSAY LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 152,
    Codigo_Banco: '0277',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO DE LA PEQUENA EMPRESA GUALA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 154,
    Codigo_Banco: '0286',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO FAMILIA AUSTRAL',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 155,
    Codigo_Banco: '0291',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO CRISTO REY',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 156,
    Codigo_Banco: '0503',
    Nombre_Banco: 'COOP A Y C 20 FEBRERO LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 157,
    Codigo_Banco: '0070',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO 15 DE ABRIL LTDA',
    Banco_Local: true,
    Url: 'https://www.coop15abril.fin.ec/servicios.php?info=SimulaCredito',
  },
  {
    Id_Banco: 158,
    Codigo_Banco: '0471',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO HUAQUILLAS LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 159,
    Codigo_Banco: '0473',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO CAC-CICA MIES',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 160,
    Codigo_Banco: '0477',
    Nombre_Banco: 'COOP DE A Y C MAQUITA CUSHUN LTDA',
    Banco_Local: true,
    Url: 'http://www.maquitacushun.fin.ec/joomla/creditos/consumo.html',
  },
  {
    Id_Banco: 161,
    Codigo_Banco: '0483',
    Nombre_Banco: 'COOP DE A Y C SANTA ROSA DE PAUTAN LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 162,
    Codigo_Banco: '0484',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO SAN MIGUEL DE SIGCHOS',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 163,
    Codigo_Banco: '0487',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO QUILANGA LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 164,
    Codigo_Banco: '0492',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO CACPE CELICA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 165,
    Codigo_Banco: '0495',
    Nombre_Banco: 'COOP DE A Y C LUCHA CAMPESINA LTDA ',
    Banco_Local: true,
    Url: 'http://www.coacluchacampesina.fin.ec/index.php/crediflash/',
  },
  {
    Id_Banco: 166,
    Codigo_Banco: '0497',
    Nombre_Banco: 'COOP DE A Y C MAQUITA CUSHUNCHIC LTDA',
    Banco_Local: true,
    Url: 'http://www.maquita.fin.ec/credito/',
  },
  {
    Id_Banco: 167,
    Codigo_Banco: '0498',
    Nombre_Banco: 'COOP A Y C FOCLA',
    Banco_Local: true,
    Url: 'http://focla.com.ec/credito/',
  },
  {
    Id_Banco: 168,
    Codigo_Banco: '0501',
    Nombre_Banco: 'COOP DE A Y C GENERAL RUMINAHUI',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 169,
    Codigo_Banco: '0584',
    Nombre_Banco: 'COOP DE SERV MULTIPLES AGRO VIDA',
    Banco_Local: true,
    Url: 'https://coosemavecuador.wordpress.com/',
  },
  {
    Id_Banco: 170,
    Codigo_Banco: '0600',
    Nombre_Banco: 'COOP. DE A. Y C. INDIGENA ALFA Y OMEGA LTDA',
    Banco_Local: true,
    Url: 'https://alfayomega.fin.ec/credito.php',
  },
  {
    Id_Banco: 172,
    Codigo_Banco: '0605',
    Nombre_Banco: 'COOP. DE A. Y C. EL TESORO PILLARENO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 173,
    Codigo_Banco: '0606',
    Nombre_Banco: 'COOP. DE A. Y C. KISAPINCHA LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 174,
    Codigo_Banco: '0607',
    Nombre_Banco: 'COOP. DE A. Y C. JUVENTUD UNIDA LTDA.',
    Banco_Local: true,
    Url: 'https://www.coopjep.fin.ec/productos-servicios/creditos/credijep',
  },
  {
    Id_Banco: 175,
    Codigo_Banco: '0608',
    Nombre_Banco: 'COOP. DE A. Y C. UNION QUISAPINCHA LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 176,
    Codigo_Banco: '0609',
    Nombre_Banco: 'COOP. DE A. Y C. 13 DE ABRIL LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 177,
    Codigo_Banco: '0610',
    Nombre_Banco: 'COOP. DE A. Y C. SALINAS LTDA.',
    Banco_Local: true,
    Url: 'https://coacsalinas.fin.ec/productos-y-servicios/creditos/',
  },
  {
    Id_Banco: 178,
    Codigo_Banco: '0611',
    Nombre_Banco: 'COOP. DE A. Y C. SAN PEDRO LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 179,
    Codigo_Banco: '0613',
    Nombre_Banco: 'COOP. DE A. Y C. COOPINDIGENA LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 180,
    Codigo_Banco: '0614',
    Nombre_Banco: 'COOP. DE A. Y C. LA UNION LTDA.',
    Banco_Local: true,
    Url: 'https://www.cooperativalaunion.com.ec/servicios/credito/credito-de-consumo-prioritario',
  },
  {
    Id_Banco: 181,
    Codigo_Banco: '0615',
    Nombre_Banco: 'COOP. DE A. Y C. PADRE VICENTE PONCE RUBIO',
    Banco_Local: true,
    Url: 'http://coopvpr.com.ec/COOP/credito/',
  },
  {
    Id_Banco: 184,
    Codigo_Banco: '0328',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO SAN GABRIEL LTDA.',
    Banco_Local: true,
    Url: 'https://sangabriel.fin.ec/simulador/',
  },
  {
    Id_Banco: 185,
    Codigo_Banco: '0332',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO SEMILLA DEL PROGRESO LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 186,
    Codigo_Banco: '0334',
    Nombre_Banco: 'COOP. DE AHORRO Y CRED. SANTA ROSA LTDA',
    Banco_Local: true,
    Url: 'https://www.coopacs.fin.ec/creditos',
  },
  {
    Id_Banco: 187,
    Codigo_Banco: '0206',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO 29 DE OCTUBRE',
    Banco_Local: true,
    Url: 'https://www.29deoctubre.fin.ec/simuladores/',
  },
  {
    Id_Banco: 188,
    Codigo_Banco: '0527',
    Nombre_Banco: 'COOP. DE A. Y C. SOL DE LOS ANDES LTDA.',
    Banco_Local: true,
    Url: 'https://coacsoldelosandes.fin.ec/servicios/',
  },
  {
    Id_Banco: 194,
    Codigo_Banco: '0549',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO MIGRANTE SOLIDARIO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 195,
    Codigo_Banco: '0551',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO SAN JOSE EL AIRO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 197,
    Codigo_Banco: '0565',
    Nombre_Banco: 'COOP CREDIUNION',
    Banco_Local: true,
    Url: 'https://co-opcreditunion.com/loans/',
  },
  {
    Id_Banco: 198,
    Codigo_Banco: '0324',
    Nombre_Banco: 'COOP. CALCETA LTDA',
    Banco_Local: true,
    Url: 'https://www.coopcalcetaltda.fin.ec/credito.html',
  },
  {
    Id_Banco: 199,
    Codigo_Banco: '0325',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO 9 DE OCTUBRE LTDA',
    Banco_Local: true,
    Url: 'http://www.9octubre.fin.ec/',
  },
  {
    Id_Banco: 200,
    Codigo_Banco: '0327',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO D LA PEQ EMPR CACPE BIBLIAN',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 201,
    Codigo_Banco: '0330',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO SAN MIGUEL DE LOS BANCOS',
    Banco_Local: true,
    Url: 'http://coacsanmiguel.fin.ec/CoacSmb/index.php?option=com_wrapper&view=wrapper&Itemid=606',
  },
  {
    Id_Banco: 203,
    Codigo_Banco: '0333',
    Nombre_Banco: 'COOP. AHORRO. Y CREDI. MUJERES UNIDAS TANTANAKUSHK',
    Banco_Local: true,
    Url: 'https://www.cacmu.fin.ec/web/credito-de-consumo/',
  },
  {
    Id_Banco: 204,
    Codigo_Banco: '0348',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO LLANGANATES',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 205,
    Codigo_Banco: '0571',
    Nombre_Banco: 'COOP. DE A. Y C. SUMAK SAMY LTDA.',
    Banco_Local: true,
    Url: 'http://www.sumaksamy.com/productos-creditos#credito',
  },
  {
    Id_Banco: 206,
    Codigo_Banco: '0604',
    Nombre_Banco: 'COOP. DE A. Y C. CHIBULEO LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 207,
    Codigo_Banco: '0502',
    Nombre_Banco: 'COOP DE A Y C FINANCIERA INDIGENA LTDA',
    Banco_Local: true,
    Url: 'http://coac-cacfi.blogspot.com/p/servicios.html',
  },
  {
    Id_Banco: 208,
    Codigo_Banco: '0504',
    Nombre_Banco: 'COOP DE A Y C  DEL COL. FISC. VICENTE ROCAFUERTE',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 210,
    Codigo_Banco: '0512',
    Nombre_Banco: 'COOP DE A Y C ESCENCIA INDIGENA LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 211,
    Codigo_Banco: '0515',
    Nombre_Banco: 'COOP DE A Y C DE LA PEQ EMPRESA CACPE MACARA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 212,
    Codigo_Banco: '0518',
    Nombre_Banco: 'COOP DE A Y C 16 DE JUNIO',
    Banco_Local: true,
    Url: 'https://coop16dejunio.com/wp/credito-de-consumo-prioritario/',
  },
  {
    Id_Banco: 213,
    Codigo_Banco: '0526',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO FASAYNAN LTDA',
    Banco_Local: true,
    Url: 'http://coopfasaynan.fin.ec/servicios',
  },
  {
    Id_Banco: 215,
    Codigo_Banco: '0556',
    Nombre_Banco: 'COOP SOLIDARIA DE GUALAQUIZA',
    Banco_Local: true,
    Url: 'https://cacpeg.fin.ec/v2/credito.html',
  },
  {
    Id_Banco: 217,
    Codigo_Banco: '0569',
    Nombre_Banco: 'C. DE A. Y C COOPAC AUSTRO LTDA (MIESS)',
    Banco_Local: true,
    Url: 'https://www.coopacaustro.fin.ec/consumo/',
  },
  {
    Id_Banco: 218,
    Codigo_Banco: '0577',
    Nombre_Banco: 'C. DE A Y C. EDUCADORES DE EL ORO LTD',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 219,
    Codigo_Banco: '0583',
    Nombre_Banco: 'CORP. DE DES. SOCIAL Y FINANC  ISLAS ENCANTADAS',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 220,
    Codigo_Banco: '0590',
    Nombre_Banco: 'COOP DE A Y C FENIX',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 221,
    Codigo_Banco: '0586',
    Nombre_Banco: 'C. DE A Y C 4 DE OCT. SAN FCO. DE CHAMBO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 222,
    Codigo_Banco: '0513',
    Nombre_Banco: 'COOP DE A Y C UNION MERCEDARIA LTDA',
    Banco_Local: true,
    Url: 'http://unionmercedaria.com/creditos.html',
  },
  {
    Id_Banco: 234,
    Codigo_Banco: '0576',
    Nombre_Banco: 'C. DE A.Y C. EL COMERCIANTE LTDA (MIESS)',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 235,
    Codigo_Banco: '0579',
    Nombre_Banco: 'COOPERATIVA DE AH. Y CREDITO RIOCHICO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 236,
    Codigo_Banco: '0079',
    Nombre_Banco: 'COOP.DE AHORRO Y CREDITO POLICIA NACIONAL',
    Banco_Local: true,
    Url: 'https://cpn.fin.ec/frontend/web/site/creditoconsumoinmediato',
  },
  {
    Id_Banco: 237,
    Codigo_Banco: '0350',
    Nombre_Banco: 'COOP.AHO Y CREDITO DE LA PEQ. EMP. DE LOJA CACPE',
    Banco_Local: true,
    Url: 'https://cacpeloja.fin.ec/credito-de-consumo/?lang=eS',
  },
  {
    Id_Banco: 238,
    Codigo_Banco: '0603',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO CREA LTDA ( MIES)',
    Banco_Local: true,
    Url: 'https://www.crea.fin.ec/index.php/productosserv/creditos/solicitud-creditos',
  },
  {
    Id_Banco: 239,
    Codigo_Banco: '0454',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO PILAHUIN ',
    Banco_Local: true,
    Url: 'https://www.pilahuintio.ec/web/creditos.html',
  },
  {
    Id_Banco: 240,
    Codigo_Banco: '0456',
    Nombre_Banco: 'COOP. A. Y C. CAMARA DE COMERCIO DE PINDAL CADECOP',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 241,
    Codigo_Banco: '0465',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO PILAHUIN TIO LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 242,
    Codigo_Banco: '0468',
    Nombre_Banco: 'COOP DE A Y C CREDISUR LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 243,
    Codigo_Banco: '0476',
    Nombre_Banco: 'COOP A Y C ECUAFUTURO LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 244,
    Codigo_Banco: '0478',
    Nombre_Banco: 'COOP DE A Y C VALLES DEL LIRIO',
    Banco_Local: true,
    Url: 'http://coopvallesdelirio.com/productos/cr%C3%A9ditos.html',
  },
  {
    Id_Banco: 245,
    Codigo_Banco: '0480',
    Nombre_Banco: 'COOP A Y C CARROCEROS DE TUNGURAHUA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 246,
    Codigo_Banco: '0489',
    Nombre_Banco: 'COOP DE A Y C CREDIAMIGO LTDA LOJA MIES',
    Banco_Local: true,
    Url: 'https://crediamigo.fin.ec/index.php/para-el-consumo/',
  },
  {
    Id_Banco: 247,
    Codigo_Banco: '0490',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO FORTUNA MIES',
    Banco_Local: true,
    Url: 'https://www.coopfortuna.fin.ec/contenido/subseccion/9',
  },
  {
    Id_Banco: 248,
    Codigo_Banco: '0494',
    Nombre_Banco: 'COOP DE A Y C SUMAC LLACTA LTDA',
    Banco_Local: true,
    Url: 'https://www.coacsumacllacta.fin.ec/microcredito/',
  },
  {
    Id_Banco: 249,
    Codigo_Banco: '0496',
    Nombre_Banco: 'COOP DE A Y C GUAMOTE LTDA ',
    Banco_Local: true,
    Url: 'http://www.guamoteltda.fin.ec/index.php?option=com_content&view=article&id=116&Itemid=1738',
  },
  {
    Id_Banco: 250,
    Codigo_Banco: '0511',
    Nombre_Banco: 'COOP DE A Y C PIJAL',
    Banco_Local: true,
    Url: 'http://coacpijal.com/productos-financieros/',
  },
  {
    Id_Banco: 252,
    Codigo_Banco: '0276',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO TENA LTDA.',
    Banco_Local: true,
    Url: 'https://cooptena.fin.ec/productos-financieros/creditos/',
  },
  {
    Id_Banco: 253,
    Codigo_Banco: '0278',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO ALIANZA MINAS LTDA.',
    Banco_Local: true,
    Url: 'https://www.coopalianzaminas.com/index.php/productos/microcredito/',
  },
  {
    Id_Banco: 254,
    Codigo_Banco: '0279',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO PEDRO MONCAYO LTDA.',
    Banco_Local: true,
    Url: 'https://www.copedromoncayo.fin.ec/index.php/nuestros-productos/credito/credito-inmediato',
  },
  {
    Id_Banco: 256,
    Codigo_Banco: '0281',
    Nombre_Banco: 'COOP. A Y C PROVIDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 258,
    Codigo_Banco: '0283',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO SAN JOSE S.J.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 259,
    Codigo_Banco: '0285',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO SENOR DE GIRON',
    Banco_Local: true,
    Url: 'https://www.coacgiron.fin.ec/#/services',
  },
  {
    Id_Banco: 262,
    Codigo_Banco: '0289',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO SAN ANTONIO LTDA.',
    Banco_Local: true,
    Url: 'http://www.coopsanantonio.fin.ec/cd_consumo.html',
  },
  {
    Id_Banco: 263,
    Codigo_Banco: '0290',
    Nombre_Banco: 'COOPERATIVA 15 DE AGOSTO PILACOTO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 264,
    Codigo_Banco: '0292',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO EDUCADORES DE CHIMBORAZO',
    Banco_Local: true,
    Url: 'http://www.coaceducadoreschimborazo.fin.ec/index.php?option=com_content&view=article&id=44&Itemid=24',
  },
  {
    Id_Banco: 265,
    Codigo_Banco: '0293',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO MINGA LTDA.',
    Banco_Local: true,
    Url: 'https://www.coopminga.com/calcule-su-credito/',
  },
  {
    Id_Banco: 266,
    Codigo_Banco: '0294',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO 4 DE OCTUBRE LTDA.',
    Banco_Local: true,
    Url: 'https://www.4deoctubre.net/de-consumo/',
  },
  {
    Id_Banco: 267,
    Codigo_Banco: '0405',
    Nombre_Banco: 'COOP AHORRO Y CREDITO FUNDESARROLLO ',
    Banco_Local: true,
    Url: 'http://coopfundesarrollo.blogspot.com/p/productos-financieros.html',
  },
  {
    Id_Banco: 268,
    Codigo_Banco: '0409',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO INTEGRAL',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 269,
    Codigo_Banco: '0411',
    Nombre_Banco: 'COOP  AHORRO Y CREDITO CAMARA COMERCIO DE AMBATO',
    Banco_Local: true,
    Url: 'https://www.ccca.fin.ec/microempresas-microcredito/',
  },
  {
    Id_Banco: 270,
    Codigo_Banco: '0508',
    Nombre_Banco: 'COOP A Y C HUINARA LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 271,
    Codigo_Banco: '0415',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO DORADO LTDA ',
    Banco_Local: true,
    Url: 'http://www.eldoradocoop.com/prestamos.html',
  },
  {
    Id_Banco: 272,
    Codigo_Banco: '0417',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO ARTESANOS  LTDA',
    Banco_Local: true,
    Url: 'https://www.coopartesanos.fin.ec/credito/',
  },
  {
    Id_Banco: 275,
    Codigo_Banco: '0208',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO COTOCOLLAO',
    Banco_Local: true,
    Url: 'http://cooperativacotocollao.fin.ec/Product/Credit',
  },
  {
    Id_Banco: 277,
    Codigo_Banco: '0403',
    Nombre_Banco: 'COOP AHORRO Y CREDITO MI TIERRA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 278,
    Codigo_Banco: '0404',
    Nombre_Banco: 'COOP AHORRO Y CREDITO DE LA PEQ EMP CACPE YANZATZA',
    Banco_Local: true,
    Url: 'https://www.cacpey.fin.ec/cacpey/ahorro-futuro-cacpey',
  },
  {
    Id_Banco: 280,
    Codigo_Banco: '0408',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO NUEVA HUANCAVILCA',
    Banco_Local: true,
    Url: 'https://www.coacnuevahuancavilca.com/credito-de-consumo/',
  },
  {
    Id_Banco: 281,
    Codigo_Banco: '0412',
    Nombre_Banco: 'COOP AHORRO Y CREDITO MUSHUC RUNA LTDA',
    Banco_Local: true,
    Url: 'https://www.mushucruna.com/simulaCredito.php',
  },
  {
    Id_Banco: 282,
    Codigo_Banco: '0414',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO AMBATO LTDA',
    Banco_Local: true,
    Url: 'https://www.cooperativaambato.com/index.php/productos/creditos',
  },
  {
    Id_Banco: 283,
    Codigo_Banco: '0419',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO HUAYCO PUNGO LTDA',
    Banco_Local: true,
    Url: 'http://www.coachuaycopungo.fin.ec/?page_id=25',
  },
  {
    Id_Banco: 284,
    Codigo_Banco: '0421',
    Nombre_Banco: 'COOP AHORRO Y CREDITO PADRE JULIAN LORENTE LTDA',
    Banco_Local: true,
    Url: 'https://www.lorente.fin.ec/productos-finacieros/creditos',
  },
  {
    Id_Banco: 285,
    Codigo_Banco: '0423',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO MARCABELI LTDA',
    Banco_Local: true,
    Url: 'http://www.coacmarcabeli.fin.ec/',
  },
  {
    Id_Banco: 286,
    Codigo_Banco: '0425',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO PUERTO LOPEZ LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 287,
    Codigo_Banco: '0426',
    Nombre_Banco: 'COOP AHORRO Y CREDITO CAM  COMERCIO CANTON BOLIVAR',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 288,
    Codigo_Banco: '0428',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO SAN JORGE LTDA',
    Banco_Local: true,
    Url: 'https://www.coacsanjorge.fin.ec/creditospage',
  },
  {
    Id_Banco: 289,
    Codigo_Banco: '0410',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO ERCO LTDA',
    Banco_Local: true,
    Url: 'https://www.cooperco.fin.ec/creditos',
  },
  {
    Id_Banco: 290,
    Codigo_Banco: '0416',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO NUESTROS ABUELOS LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 291,
    Codigo_Banco: '0418',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO SANTA ANITA LTDA ',
    Banco_Local: true,
    Url: 'http://www.coacsantaanita.fin.ec/sitio/creditos/',
  },
  {
    Id_Banco: 292,
    Codigo_Banco: '0422',
    Nombre_Banco: 'COOP AHORRO Y CREDITO CARIAMANGA LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 293,
    Codigo_Banco: '0424',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO AGRICOLA JUNIN LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 294,
    Codigo_Banco: '0427',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO NUEVA ESPERANZA',
    Banco_Local: true,
    Url: 'https://www.coacnuevaesperanza.com/',
  },
  {
    Id_Banco: 295,
    Codigo_Banco: '0429',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO FERNANDO DAQUILEMA ',
    Banco_Local: true,
    Url: 'https://www.coopdaquilema.com/creditos/',
  },
  {
    Id_Banco: 297,
    Codigo_Banco: '0076',
    Nombre_Banco: 'COOP. JARDIN AZUAYO',
    Banco_Local: true,
    Url: 'https://www.jardinazuayo.fin.ec/coacja/web/credito',
  },
  {
    Id_Banco: 298,
    Codigo_Banco: '0616',
    Nombre_Banco: 'COOP. SAN PABLO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 301,
    Codigo_Banco: '0612',
    Nombre_Banco: 'COOP. DE A. Y C. LOS CHASQUIS PASTOCALLE LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 304,
    Codigo_Banco: '0587',
    Nombre_Banco: 'C. DE A Y C 26 DE SEPTBRE LAZARO CONDO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 305,
    Codigo_Banco: '0329',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO SAN JOSE LTDA',
    Banco_Local: true,
    Url: 'https://microfides.com/san-jose-ecuador/',
  },
  {
    Id_Banco: 306,
    Codigo_Banco: '0335',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO ONCE DE JUNIO',
    Banco_Local: true,
    Url: 'http://www.oncedejunio.fin.ec/proCreConsumo.html',
  },
  {
    Id_Banco: 308,
    Codigo_Banco: '0620',
    Nombre_Banco: 'COOP. DE A Y C EDUCADORES DE PASTAZA LTDA.',
    Banco_Local: true,
    Url: 'https://www.cacep1.fin.ec/productos-y-servicios.html',
  },
  {
    Id_Banco: 309,
    Codigo_Banco: '0621',
    Nombre_Banco: 'COOP. DE A. Y C. GRAMEEN AMAZONAS',
    Banco_Local: true,
    Url: 'http://www.grameenamazonas.org.ec/',
  },
  {
    Id_Banco: 310,
    Codigo_Banco: '0622',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO SAN BARTOLO LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 315,
    Codigo_Banco: '0625',
    Nombre_Banco: 'COOP. DE A Y C. SERVIDORES MUNICIPALES DE CUENCA',
    Banco_Local: true,
    Url: 'http://www.copemc.org/?page_id=191',
  },
  {
    Id_Banco: 317,
    Codigo_Banco: '0626',
    Nombre_Banco: 'COOP. DE AHO Y CREDITO EDUC.DEL TUNGURAHUA LTDA.',
    Banco_Local: true,
    Url: 'http://www.coacet.fin.ec/productos-y-servicios/creditos/',
  },
  {
    Id_Banco: 318,
    Codigo_Banco: '0627',
    Nombre_Banco: 'COOP. DE A. Y C. INDIGENA SAC PELILEO',
    Banco_Local: true,
    Url: 'https://www.coacsac.com/index.php/productos',
  },
  {
    Id_Banco: 319,
    Codigo_Banco: '0628',
    Nombre_Banco: 'COOP. DE A. Y C. INTERCULTURAL TAWANTINSUYU LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 320,
    Codigo_Banco: '0629',
    Nombre_Banco: 'COOP.DE AHORRO Y CREDITO MICROEMPRESARIAL SUCRE',
    Banco_Local: true,
    Url: 'https://www.coacmes.com/servicios/planes-de-creditos',
  },
  {
    Id_Banco: 322,
    Codigo_Banco: '0630',
    Nombre_Banco: 'COOP. DE A. Y C. PUJILI LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 323,
    Codigo_Banco: '0631',
    Nombre_Banco: 'COOP. DE A. Y C. CREDIL LTDA.',
    Banco_Local: true,
    Url: 'https://www.coopcredil.com/microcredito.html',
  },
  {
    Id_Banco: 324,
    Codigo_Banco: '0632',
    Nombre_Banco: 'COOP. DE A. Y C. MUSHUK WASI LTDA ( MIES )',
    Banco_Local: true,
    Url: 'https://www.kullkiwasi.com.ec/credi-efectivo/',
  },
  {
    Id_Banco: 329,
    Codigo_Banco: '0633',
    Nombre_Banco: 'COOP. A y C CAMARA DE COMERCIO INDIGENA DE GUAMOTE',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 330,
    Codigo_Banco: '0634',
    Nombre_Banco: 'COOP. PROD. Y DES. AGR. COOPRODESA LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 332,
    Codigo_Banco: '0635',
    Nombre_Banco: 'COOP. SIMON BOLIVAR LTDA.',
    Banco_Local: true,
    Url: 'http://www.financieracoopsimonbolivar.com/',
  },
  {
    Id_Banco: 335,
    Codigo_Banco: '0636',
    Nombre_Banco: 'COOP. SAN ANTONIO DE TOACASO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 337,
    Codigo_Banco: '9999',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO PROFUTURO LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 338,
    Codigo_Banco: '0998',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO SANTA ISABEL LTDA.',
    Banco_Local: true,
    Url: 'https://www.coacsantaisabel.fin.ec/productos-servicios/credito/',
  },
  {
    Id_Banco: 339,
    Codigo_Banco: '0997',
    Nombre_Banco: 'COOP. DE A. Y C. DEL EMIGRANTE ECUATORIANO Y SU FA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 340,
    Codigo_Banco: '0996',
    Nombre_Banco: 'COOP. DE A. Y C. NUKA LLAKTA LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 341,
    Codigo_Banco: '0995',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO INTI WASI LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 343,
    Codigo_Banco: '0993',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO SOLIDARIA LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 344,
    Codigo_Banco: '0992',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO ECONOMIA DEL SUR ',
    Banco_Local: true,
    Url: 'http://cooperativadeahorroycredito.com/',
  },
  {
    Id_Banco: 345,
    Codigo_Banco: '0991',
    Nombre_Banco: 'COOP. DE A. Y C. ILINIZA LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 347,
    Codigo_Banco: '0989',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO GANANSOL LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 348,
    Codigo_Banco: '0988',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO SANTO DOMINGO',
    Banco_Local: true,
    Url: 'http://www.coopsantodomingo.com/?page_id=26',
  },
  {
    Id_Banco: 349,
    Codigo_Banco: '0999',
    Nombre_Banco: 'COOP.DE AHORRO Y CREDITO GUACHAPALA LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 350,
    Codigo_Banco: '1000',
    Nombre_Banco: 'COOP.AHORRO Y CREDITO FRANDESC.LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 352,
    Codigo_Banco: '1002',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO SARAGURO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 353,
    Codigo_Banco: '1003',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO CANAR LTDA',
    Banco_Local: true,
    Url: 'http://www.coaccanar.fin.ec/index.php',
  },
  {
    Id_Banco: 354,
    Codigo_Banco: '1004',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO SOCIO AMIGO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 357,
    Codigo_Banco: '1007',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO 1 DE JULIO',
    Banco_Local: true,
    Url: 'http://coac1dejulio.com/index.php/creditos/consumo',
  },
  {
    Id_Banco: 359,
    Codigo_Banco: '1009',
    Nombre_Banco: 'COOP. DE A. Y C. BANOS DE AGUA SANTA LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 299,
    Codigo_Banco: '0617',
    Nombre_Banco: 'COOP. 15 DE DICIEMBRE',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 800,
    Codigo_Banco: '1058',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO CADECOG GONZANAMA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 805,
    Codigo_Banco: '1063',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO 29 DE ENERO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 825,
    Codigo_Banco: '1083',
    Nombre_Banco: 'COOP DE A Y C UNION EL EJIDO',
    Banco_Local: true,
    Url: 'http://www.unionelejido.com/creditos/consumo/',
  },
  {
    Id_Banco: 835,
    Codigo_Banco: '1093',
    Nombre_Banco: 'COOP DE AHORRO Y CREDITO MUSHUK YUYAY',
    Banco_Local: true,
    Url: 'http://mushukyuyay.fin.ec/web/index.php/servicios',
  },
  {
    Id_Banco: 838,
    Codigo_Banco: '1096',
    Nombre_Banco: 'COOP DE A Y C INDIGENA SAC LTDA',
    Banco_Local: true,
    Url: 'https://www.coacsac.com/index.php/productos/requisitos-para-creditos',
  },
  {
    Id_Banco: 881,
    Codigo_Banco: '1139',
    Nombre_Banco: 'COOP DE A Y C LUZ DEL VALLE',
    Banco_Local: true,
    Url: 'https://www.luzdelvalle.fin.ec/credito-convenio/',
  },
  {
    Id_Banco: 885,
    Codigo_Banco: '1161',
    Nombre_Banco: 'COOP. DE A. Y C. WARMIKUNAPAK RIKCHARI LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 895,
    Codigo_Banco: '1162',
    Nombre_Banco: 'COOP. DE A. Y C. REY DAVID LTDA',
    Banco_Local: true,
    Url: 'http://www.coacreydavid.com/index.php/productos/credito-para-toda-necesidad.html',
  },
  {
    Id_Banco: 896,
    Codigo_Banco: '1163',
    Nombre_Banco: 'COOP. DE A. Y C. KULLKI WASI LTDA.',
    Banco_Local: true,
    Url: 'https://www.kullkiwasi.com.ec/credito/',
  },
  {
    Id_Banco: 897,
    Codigo_Banco: '1164',
    Nombre_Banco: 'COOP. DE A. Y C. CORP. ORG. CAMPESINAS DE QUISAPIN',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 898,
    Codigo_Banco: '1165',
    Nombre_Banco: 'COOP. DE A. Y C. PRODUACTIVA LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 899,
    Codigo_Banco: '1166',
    Nombre_Banco: 'COOP. DE A. Y C. TAMBOLOMA LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 900,
    Codigo_Banco: '1167',
    Nombre_Banco: 'COOP DE A. Y C. PUSHAK RUNA HOMBRE LIDER',
    Banco_Local: true,
    Url: 'http://www.pushakruna.com/index.php/servicios',
  },
  {
    Id_Banco: 901,
    Codigo_Banco: '1168',
    Nombre_Banco: 'COOP. DE A. Y C. 15 DE AGOSTO LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 902,
    Codigo_Banco: '1169',
    Nombre_Banco: 'COOP. DE A. Y C. MIGRANTES DEL ECUADOR LTDA',
    Banco_Local: true,
    Url: 'http://www.migrantesdelecuador.com/producto/crediflash/micromigrantes.html',
  },
  {
    Id_Banco: 903,
    Codigo_Banco: '1170',
    Nombre_Banco: 'COOP DE A. Y C. SINCHI CODEFIS',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 904,
    Codigo_Banco: '1171',
    Nombre_Banco: 'COOP. DE A. Y C. CACIQUE GURITAVE',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 905,
    Codigo_Banco: '1172',
    Nombre_Banco: 'COAC SOLIDARIDAD Y PROGRESO ORIENTAL',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 906,
    Codigo_Banco: '1173',
    Nombre_Banco: 'COAC ACHIK INTI LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 907,
    Codigo_Banco: '1174',
    Nombre_Banco: 'COOP. DE A. Y C. AFROECUATORIANA DE LA PEQ. EMP. L',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 908,
    Codigo_Banco: '1175',
    Nombre_Banco: 'COOP DE A. Y C. CAMINO DE LUZ LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 909,
    Codigo_Banco: '1176',
    Nombre_Banco: 'COAC A Y C EDUCADORES DE BOLIVAR',
    Banco_Local: true,
    Url: 'http://www.coopebolivar.fin.ec/',
  },
  {
    Id_Banco: 910,
    Codigo_Banco: '1177',
    Nombre_Banco: 'COAC SAN MIGUEL LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 911,
    Codigo_Banco: '1178',
    Nombre_Banco: 'COOP. DE A. Y C. SALINERITA',
    Banco_Local: true,
    Url: 'http://refidersn.com/',
  },
  {
    Id_Banco: 912,
    Codigo_Banco: '1179',
    Nombre_Banco: 'COOP. DE A. Y C. BOLA AMARILLA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 913,
    Codigo_Banco: '1180',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO FOCAZSUM LTDA.',
    Banco_Local: true,
    Url: 'http://www.focazsumjipijapa.com/cooperativa.html',
  },
  {
    Id_Banco: 914,
    Codigo_Banco: '1181',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO VISION DE LOS ANDES',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 915,
    Codigo_Banco: '1182',
    Nombre_Banco: 'COOP. DE A. Y C. SENOR DEL ARBOL',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 916,
    Codigo_Banco: '1183',
    Nombre_Banco: 'COOP. DE A. Y C. ALIANZA FINANCIERA DE COTOPAXI LT',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 917,
    Codigo_Banco: '1184',
    Nombre_Banco: 'COOP. DE A. Y C. CAMARA DE COMERCIO DE LA MANA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 918,
    Codigo_Banco: '1185',
    Nombre_Banco: 'COOP DE A. Y C. INDIGENA SAC LATACUNGA LTDA',
    Banco_Local: true,
    Url: 'https://www.coacsac.com/index.php/productos/requisitos-para-creditos',
  },
  {
    Id_Banco: 919,
    Codigo_Banco: '1186',
    Nombre_Banco: 'COOP. DE A. Y C. SOLIDARIA LTDA.- COTOPAXI',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 920,
    Codigo_Banco: '1187',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO MIGRANTES Y EMPREN',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 921,
    Codigo_Banco: '1188',
    Nombre_Banco: 'COOP. DE A. Y C. DEL SINDICATO DE CHOFERES PROFESI',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 922,
    Codigo_Banco: '1189',
    Nombre_Banco: 'COOP.DE A. Y C. DE CRECIMIENTO ECONOMICO RENTABLE ',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 923,
    Codigo_Banco: '1190',
    Nombre_Banco: 'COOP DE A. Y C. EDUCADORES DE LOJA',
    Banco_Local: true,
    Url: 'http://www.cacel.com.ec/main.html',
  },
  {
    Id_Banco: 924,
    Codigo_Banco: '1191',
    Nombre_Banco: 'COOP DE A. Y C. 22 DE JUNIO-ORIANGA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 925,
    Codigo_Banco: '1192',
    Nombre_Banco: 'COAC PROBIENESTAR LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 926,
    Codigo_Banco: '1193',
    Nombre_Banco: 'COAC LOJA INTERNACIONAL LTDA.',
    Banco_Local: true,
    Url: 'http://coaclojainternacionaltda.fin.ec/2018-04-01-01-28-58/consultar',
  },
  {
    Id_Banco: 927,
    Codigo_Banco: '1194',
    Nombre_Banco: 'COAC 23 DE ENERO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 928,
    Codigo_Banco: '1195',
    Nombre_Banco: 'COOP. A Y C CAMARA DE COMERCIO CANTON -EL CARMEN L',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 929,
    Codigo_Banco: '1196',
    Nombre_Banco: 'COOP. DE AHORRO Y CRED. LA INMACULADA DE SAN PLACI',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 930,
    Codigo_Banco: '1197',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO EL PARAISO MANGA D',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 931,
    Codigo_Banco: '1198',
    Nombre_Banco: 'COAC DE LOS PROFESORES EMPLEADOS Y TRABAJADORES DE',
    Banco_Local: true,
    Url: 'https://www.cacspmec.fin.ec/institucion.html',
  },
  {
    Id_Banco: 932,
    Codigo_Banco: '1199',
    Nombre_Banco: 'COOP. DE A.Y C. PRODUC. AHORRO INVERS. SERVICIO P.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 933,
    Codigo_Banco: '1200',
    Nombre_Banco: 'COOP. DE A. Y C. CONSTRUCTOR DEL DESARROLLO SOLIDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 934,
    Codigo_Banco: '1201',
    Nombre_Banco: 'COOP. A.YC.SAGRADA FAMILIA SOLIDARIDAD PASTORAL IN',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 935,
    Codigo_Banco: '1202',
    Nombre_Banco: 'COOP. DE A. Y C. NAUPA KAUSAY',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 936,
    Codigo_Banco: '1203',
    Nombre_Banco: 'COOP. DE A. Y C. EL ALTAR LTDA.',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 937,
    Codigo_Banco: '1204',
    Nombre_Banco: 'COOP. DE A. Y C. NUEVA ALIANZA DE CHIMBORAZO LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 938,
    Codigo_Banco: '1205',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO DE LA PEQUENA EMPRESA DE',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 949,
    Codigo_Banco: '1231',
    Nombre_Banco: 'COOP DE A Y C INDIGENA SAC LATACUNGA LTDA ',
    Banco_Local: true,
    Url: 'https://www.coacsac.com/index.php/productos/requisitos-para-creditos',
  },
  {
    Id_Banco: 950,
    Codigo_Banco: '1232',
    Nombre_Banco: 'COOPERATIVA DE AHORRO Y CREDITO MIGRANTES EMPRENDE',
    Banco_Local: true,
    Url: 'http://www.migrantesdelecuador.com/producto/crediflash/micromigrantes.html',
  },
  {
    Id_Banco: 951,
    Codigo_Banco: '1233',
    Nombre_Banco: 'COOP DE A Y C EDUCADORES DE LOJA ',
    Banco_Local: true,
    Url: 'https://www.cacel.com.ec/simulator.html',
  },
  {
    Id_Banco: 952,
    Codigo_Banco: '1237',
    Nombre_Banco: 'COOP DE A Y C NUEVA ALIANZA DE CHIMBORAZO LTDA ',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 41,
    Codigo_Banco: '0203',
    Nombre_Banco: 'CACPECO LTDA',
    Banco_Local: true,
    Url: 'https://www.cacpeco.com/simuladores/',
  },
  {
    Id_Banco: 42,
    Codigo_Banco: '2557',
    Nombre_Banco: ' COOP DE AHORRO Y CREDITO LA MERCED',
    Banco_Local: true,
    Url: 'http://www.lamerced.fin.ec/creditos.html',
  },
  {
    Id_Banco: 43,
    Codigo_Banco: '0205',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO 23 DE JULIO',
    Banco_Local: true,
    Url: 'https://www.coop23dejulio.fin.ec/creditos-consumo/',
  },
  {
    Id_Banco: 45,
    Codigo_Banco: '0207',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO ANDALUCIA',
    Banco_Local: true,
    Url: 'https://andalucia.fin.ec/index.php?snp=YVcxbGJuVTlOamttYzJWall6MHhKbk5sWTJOcGIyNXdQVEUxSm1GeVBUWXc=432',
  },
  {
    Id_Banco: 47,
    Codigo_Banco: '0209',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO DESARROLLO PUEBLOS',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 48,
    Codigo_Banco: '0210',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO EL SAGRARIO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 49,
    Codigo_Banco: '0211',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO GUARANDA LTDA',
    Banco_Local: true,
    Url: 'http://www.guarandaltda.fin.ec/Credito/Microcre.php',
  },
  {
    Id_Banco: 51,
    Codigo_Banco: '0213',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO JEP',
    Banco_Local: true,
    Url: 'https://www.coopjep.fin.ec/productos-servicios/creditos/credijep',
  },
  {
    Id_Banco: 52,
    Codigo_Banco: '0214',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO MANUEL ',
    Banco_Local: true,
    Url: 'https://www.coopmego.com/?page_id=102',
  },
  {
    Id_Banco: 53,
    Codigo_Banco: '0514',
    Nombre_Banco: 'COOP DE A Y C CATAMAYO LTDA',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 54,
    Codigo_Banco: '0216',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO OSCUS',
    Banco_Local: true,
    Url: 'https://www.oscus.coop/index.php/productos/creditos/credioscus/',
  },
  {
    Id_Banco: 55,
    Codigo_Banco: '0217',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO PABLO MUNOZ VEGA',
    Banco_Local: true,
    Url: 'http://www.cpmv.fin.ec/index.php/modules-menu/creditos',
  },
  {
    Id_Banco: 56,
    Codigo_Banco: '0218',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO PROGRESO',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 57,
    Codigo_Banco: '0450',
    Nombre_Banco: 'COOP. A. Y C. DE LA PEQ. EMP. CACPE ZAMORA LTDA',
    Banco_Local: true,
    Url: 'https://www.cooprogreso.fin.ec/productos-y-servicios/',
  },
  {
    Id_Banco: 58,
    Codigo_Banco: '0220',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO SAN FRANCISCO',
    Banco_Local: true,
    Url: 'http://www.coac-sanfra.com/colocaciones/',
  },
  {
    Id_Banco: 60,
    Codigo_Banco: '0222',
    Nombre_Banco: 'COOP. AHORRO Y CREDITO TULCAN',
    Banco_Local: true,
    Url: 'https://www.cooptulcan.fin.ec/productos',
  },
  {
    Id_Banco: 61,
    Codigo_Banco: '0223',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO ATUNTAQUI LTDA.',
    Banco_Local: true,
    Url: 'https://finacoop.atuntaqui.fin.ec/atuntaquiltda/index.php/2014-05-30-17-48-6/credito-de-consumo',
  },
  {
    Id_Banco: 62,
    Codigo_Banco: '0224',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO COMERCIO LTDA PORTOVIEJO',
    Banco_Local: true,
    Url: 'https://www.coopcomer.fin.ec/creditos.html',
  },
  {
    Id_Banco: 63,
    Codigo_Banco: '0225',
    Nombre_Banco: 'COOP. DE AHORRO Y CREDITO LA DOLOROSA LTDA',
    Banco_Local: true,
    Url: 'https://ladolorosa.fin.ec/simulador-de-credito/',
  },
  {
    Id_Banco: 64,
    Codigo_Banco: '0226',
    Nombre_Banco: 'COOP. PREVISION AHORRO Y DESARROLLO',
    Banco_Local: true,
    Url: 'https://www.coopad.fin.ec/consumo.html',
  },
  {
    Id_Banco: 1,
    Codigo_Banco: '0010',
    Nombre_Banco: 'BANCO PICHINCHA C.A.',
    Banco_Local: true,
    Url: 'https://www.pichincha.com/portal/Principal/Empresas/Creditos',
  },
  {
    Id_Banco: 3,
    Codigo_Banco: '0001',
    Nombre_Banco: 'BANCO CENTRAL DEL ECUADOR - SPI',
    Banco_Local: true,
    Url: 'https://contenido.bce.fin.ec/contenido.php?CNT=ARB0000814',
  },
  {
    Id_Banco: 5,
    Codigo_Banco: '0039',
    Nombre_Banco: 'BANCO COMERCIAL DE MANABI',
    Banco_Local: true,
    Url: 'https://www.bcmanabi.com/#popup',
  },
  {
    Id_Banco: 17,
    Codigo_Banco: '0082',
    Nombre_Banco: 'FINANCOOP',
    Banco_Local: true,
    Url: 'https://www.financoop.net/index.php/financieros/creditos/multiuso',
  },
  {
    Id_Banco: 19,
    Codigo_Banco: '0017',
    Nombre_Banco: 'BANCO DE GUAYAQUIL S.A',
    Banco_Local: true,
    Url: 'https://www.bancoguayaquil.com/Personas/Creditos',
  },
  {
    Id_Banco: 22,
    Codigo_Banco: '0024',
    Nombre_Banco: 'BANCO CITY BANK',
    Banco_Local: true,
    Url: 'https://www.citi.com/icg/sa/latam/ecuador/',
  },
  {
    Id_Banco: 23,
    Codigo_Banco: '0025',
    Nombre_Banco: 'BANCO MACHALA',
    Banco_Local: true,
    Url: 'https://www.bancomachala.com/simuladores/',
  },
  {
    Id_Banco: 25,
    Codigo_Banco: '0029',
    Nombre_Banco: 'BANCO DE LOJA',
    Banco_Local: true,
    Url: 'https://www.bancodeloja.fin.ec/Principal/Personas/Cr%C3%A9ditos',
  },
  {
    Id_Banco: 26,
    Codigo_Banco: '0030',
    Nombre_Banco: 'BANCO DEL PACIFICO',
    Banco_Local: true,
    Url: 'https://www.bancodelpacifico.com/personas/creditos',
  },
  {
    Id_Banco: 27,
    Codigo_Banco: '0032',
    Nombre_Banco: 'BANCO INTERNACIONAL',
    Banco_Local: true,
    Url: 'https://www.bancointernacional.com.ec/intercreditosPers.html',
  },
  {
    Id_Banco: 28,
    Codigo_Banco: '0034',
    Nombre_Banco: 'BANCO AMAZONAS',
    Banco_Local: true,
    Url: 'https://www.bancoamazonas.com/Banca-Personas/Cr%C3%A9ditos',
  },
  {
    Id_Banco: 29,
    Codigo_Banco: '0035',
    Nombre_Banco: 'BANCO DEL AUSTRO',
    Banco_Local: true,
    Url: 'https://www.bancodelaustro.com/Banca-Personas/Creditos/Credito-de-Consumo',
  },
  {
    Id_Banco: 30,
    Codigo_Banco: '0036',
    Nombre_Banco: 'BANCO DE LA PRODUCCION_PROMERICA',
    Banco_Local: true,
    Url: 'https://www.produbanco.com.ec/banca-minorista/cr%C3%A9ditos/',
  },
  {
    Id_Banco: 31,
    Codigo_Banco: '0037',
    Nombre_Banco: 'BANCO BOLIVARIANO',
    Banco_Local: true,
    Url: 'https://www.bolivariano.com/simuladores/',
  },
  {
    Id_Banco: 33,
    Codigo_Banco: '0042',
    Nombre_Banco: 'BANCO GENERAL RUMINAHUI S.A.',
    Banco_Local: true,
    Url: 'https://www.bgr.com.ec/bgr-consumo',
  },
  {
    Id_Banco: 34,
    Codigo_Banco: '0043',
    Nombre_Banco: 'BANCO DEL LITORAL S.A.',
    Banco_Local: true,
    Url: 'http://www.litoral.fin.ec/index.php/es/creditos',
  },
  {
    Id_Banco: 38,
    Codigo_Banco: '0059',
    Nombre_Banco: 'BANCO SOLIDARIO',
    Banco_Local: true,
    Url: 'https://www.banco-solidario.com/creditos/credito-personal',
  },
  {
    Id_Banco: 39,
    Codigo_Banco: '0201',
    Nombre_Banco: 'BANCO DELBANK S.A.',
    Banco_Local: true,
    Url: 'http://delbank.fin.ec/soluciones/creditos/',
  },
  {
    Id_Banco: 40,
    Codigo_Banco: '0202',
    Nombre_Banco: 'BANCO ECUATORIANO DE LA VIVIENDA',
    Banco_Local: true,
    Url: 'http://www.bev.fin.ec/',
  },
  {
    Id_Banco: 44,
    Codigo_Banco: '0349',
    Nombre_Banco: 'INTERDIN S.A.',
    Banco_Local: true,
    Url: 'https://www.interdin.com.ec/wps/portal/Interdin/phome/pdiners/!ut/p/a1/hdJRC4IwEMDxTxS7zc3Nx6WhphIao9xLCEWM0nqIqD59C3ztds__HzvGEUv2xE7D052Hh7tNw5X0pLfykLQ8pUUFtWrrFDQ1ciVFRyFlxIzDy43uczr-rI0PStc5ZYpVm7xjoFtqIGvWDCrhg94H8Gc0oH4bzR4JMN_ygPcB5pci4H2A-SS0f4LvH7OA9wHmmQx4H2A-igPeB5g3of8zInQ_O2LRRIk5SHNdcFn7o-KKQZkti0wmDUAZzwF2g-gTHMh9VG83z-LSrb4hKUVx/dl5/d5/L2dJQSEvUUt3SS80SmlFL1o2XzhBTEcxMjgyS09HUjIwQVExVTBETUoyMEs1/#no-back-button',
  },
  {
    Id_Banco: 69,
    Codigo_Banco: '0232',
    Nombre_Banco: 'FINANCIERA - DINERS CLUB DEL ECUADOR',
    Banco_Local: true,
    Url: 'https://www.dinersclub.com.ec/portal/personal/soluciones-financieras/tipos-de-credito',
  },
  {
    Id_Banco: 114,
    Codigo_Banco: '0060',
    Nombre_Banco: 'BANCO PROCREDIT S.A.',
    Banco_Local: true,
    Url: 'https://www.bancoprocredit.com.ec/credito-de-inversion-personal',
  },
  {
    Id_Banco: 142,
    Codigo_Banco: '0461',
    Nombre_Banco: 'BANCO DEL INSTITU ECUATORIANO DE SEGURIDAD SOCIAL',
    Banco_Local: true,
    Url: '',
  },
  {
    Id_Banco: 144,
    Codigo_Banco: '0500',
    Nombre_Banco: 'BANCO D MIRO SA',
    Banco_Local: true,
    Url: 'https://www.d-miro.com/productos/creditos/',
  },
  {
    Id_Banco: 182,
    Codigo_Banco: '0323',
    Nombre_Banco: 'BANCO PARA LA ASISTENCIA COMUNITARIA FINCA S.A.',
    Banco_Local: true,
    Url: 'https://www.finca.ec/creditos/',
  },
  {
    Id_Banco: 223,
    Codigo_Banco: '0517',
    Nombre_Banco: 'BANCO COOPNACIONAL SA',
    Banco_Local: true,
    Url: 'https://www.bancocoopnacional.com/microcredito.html',
  },
  {
    Id_Banco: 255,
    Codigo_Banco: '0280',
    Nombre_Banco: 'BCE-TRANSFERENCIAS REMESAS',
    Banco_Local: true,
    Url: 'https://www.bce.fin.ec/index.php/boletines-de-prensa-archivo/item/876-el-sistema-de-dinero-electr%C3%B3nico-incorpora-el-servicio-de-env%C3%ADo-de-remesas-desde-el-exterior',
  },
  {
    Id_Banco: 296,
    Codigo_Banco: '0061',
    Nombre_Banco: 'BANCO CAPITAL',
    Banco_Local: true,
    Url: 'https://www.bancocapital.com/banca-personas/credito-de-consumo.html',
  },
  {
    Id_Banco: 939,
    Codigo_Banco: '1206',
    Nombre_Banco: 'BANECUADOR B.P',
    Banco_Local: true,
    Url: 'https://www.banecuador.fin.ec/productos-ciudadanos/',
  },
];
